"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DropdownCheckButton = _interopRequireDefault(require("./DropdownCheckButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var DateRangeFilter = function DateRangeFilter(_ref) {
  var _ref$column = _ref.column,
      _ref$column$filterVal = _ref$column.filterValue,
      filterValue = _ref$column$filterVal === void 0 ? [] : _ref$column$filterVal,
      setFilter = _ref$column.setFilter,
      filterOptions = _ref$column.filterOptions;

  var setSelect = function setSelect(choice) {
    if (filterValue.find(function (filter) {
      return filter.id === choice.id;
    })) {
      setFilter(filterValue.filter(function (opt) {
        return opt.id !== choice.id;
      }));
    } else {
      setFilter([].concat(_toConsumableArray(filterValue), [choice]));
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", null, filterOptions.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_DropdownCheckButton.default, {
      checked: !!filterValue.find(function (filter) {
        return filter.id === option.id;
      }),
      key: option.id,
      dataTestId: option.id,
      onClick: function onClick() {
        return setSelect(option);
      }
    }, "".concat(option.min.format('MM/YY'), "-").concat(option.max.format('MM/YY')));
  }));
};

DateRangeFilter.propTypes = {
  column: _propTypes.default.shape({
    filterValue: _propTypes.default.array,
    setFilter: _propTypes.default.func,
    filterOptions: _propTypes.default.array
  }).isRequired
};
var _default = DateRangeFilter;
exports.default = _default;